"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const overlayscrollbars_react_1 = require("overlayscrollbars-react");
const useMeasure_1 = __importDefault(require("react-use/lib/useMeasure"));
const useWindowSize_1 = __importDefault(require("react-use/lib/useWindowSize"));
const Loader_1 = require("../loader/Loader");
const NothingToShow_1 = require("../nothingToShow/NothingToShow");
const ShowUp_1 = require("../showUp/ShowUp");
const CheckedElementsBar_1 = require("../checkedElementsBar/CheckedElementsBar");
const useLocale_1 = require("../../hooks/useLocale/useLocale");
const messages_1 = require("../../core/i18n/messages");
const Tooltip_1 = require("../tooltip/Tooltip");
const Pagination_1 = require("../pagination/Pagination");
const TopBar_styles_1 = require("../topBar/TopBar.styles");
const usePageLayoutStyles_1 = require("../../hooks/usePageLayoutStyles/usePageLayoutStyles");
const ObserverContextController_1 = require("./context/observer/observerContextController/ObserverContextController");
const useObserver_1 = require("./hooks/useObserver");
const HeaderItem_1 = __importDefault(require("./headerItem/HeaderItem"));
const HeaderCheckboxItem_1 = __importDefault(require("./headerCheckboxItem/HeaderCheckboxItem"));
const RowCheckboxItem_1 = __importDefault(require("./rowCheckboxItem/RowCheckboxItem"));
const RowTagItem_1 = __importDefault(require("./rowTagItem/RowTagItem"));
const RowItem_1 = __importDefault(require("./rowItem/RowItem"));
const Styled = __importStar(require("./Table.styles"));
const ADDITIONAL_PAGE_SPACE = 20;
const TableBase = ({ gridTemplateColumns, data: baseData, renderHeader, renderRow, nothingToShowText, activeRowId, onClickRow, rowsDisabled, isLoading, checkboxSelection, testIdKey, customTableHeight, rowTooltip, pagination, renderMultiActions, renderAdditionalTopElement, tableMinWidth, additionalHeaderElement, }) => {
    const { formatMessage } = (0, useLocale_1.useLocale)();
    const { tableRef } = (0, useObserver_1.useObserver)();
    const { height: windowHeight } = (0, useWindowSize_1.default)();
    const [additionalTopElementRef, { height: additionalTopElementHeight }] = (0, useMeasure_1.default)();
    const [checkedElementsBarRef, { height: checkedElementsBarHeight }] = (0, useMeasure_1.default)();
    const [multiActionsRef, { height: multiActionsHeight }] = (0, useMeasure_1.default)();
    const [paginationRef, { height: paginationHeight }] = (0, useMeasure_1.default)();
    const [tableHeaderRef, { height: tableHeaderHeight }] = (0, useMeasure_1.default)();
    const [additionalHeaderElementRef, { height: additionalHeaderElementHeight }] = (0, useMeasure_1.default)();
    const { headerHeight, paddingBottom, paddingTop } = (0, usePageLayoutStyles_1.usePageLayoutStyles)();
    const data = (0, react_1.useMemo)(() => (testIdKey ? baseData.map((value) => ({ ...value, testId: value[testIdKey] })) : baseData), [testIdKey, baseData]);
    (0, react_1.useEffect)(() => {
        if (!checkboxSelection || !data || !data.length)
            return;
        checkboxSelection.toggleChecked(data.filter((item) => checkboxSelection.checked.some((checkedItem) => checkedItem.id === item.id)));
    }, [JSON.stringify(data)]);
    const getGridTemplateColumns = () => {
        if (checkboxSelection && checkboxSelection.customGridTemplateColumnValue) {
            return `${checkboxSelection.customGridTemplateColumnValue} ${gridTemplateColumns}`;
        }
        else if (checkboxSelection) {
            return `80px ${gridTemplateColumns}`;
        }
        else {
            return gridTemplateColumns;
        }
    };
    const calculatedTableHeight = windowHeight -
        tableHeaderHeight -
        additionalTopElementHeight -
        checkedElementsBarHeight -
        multiActionsHeight -
        paginationHeight -
        additionalHeaderElementHeight -
        headerHeight -
        paddingBottom -
        paddingTop -
        TopBar_styles_1.TOP_BAR_HEIGHT -
        ADDITIONAL_PAGE_SPACE;
    const tableHeight = (0, react_1.useMemo)(() => {
        if (customTableHeight) {
            return customTableHeight(calculatedTableHeight);
        }
        else {
            return calculatedTableHeight;
        }
    }, [customTableHeight, calculatedTableHeight]);
    if (isLoading)
        return (0, jsx_runtime_1.jsx)(Loader_1.Loader, {});
    return ((0, jsx_runtime_1.jsxs)("div", { style: { minWidth: tableMinWidth }, children: [(0, jsx_runtime_1.jsx)("div", { ref: additionalTopElementRef, children: renderAdditionalTopElement && renderAdditionalTopElement() }), (0, jsx_runtime_1.jsx)("div", { ref: multiActionsRef, children: renderMultiActions && renderMultiActions() }), (0, jsx_runtime_1.jsx)("div", { ref: paginationRef, children: pagination && (0, jsx_runtime_1.jsx)(Pagination_1.Pagination, { ...pagination }) }), (0, jsx_runtime_1.jsx)("div", { ref: additionalHeaderElementRef, children: additionalHeaderElement }), (0, jsx_runtime_1.jsx)("div", { ref: checkedElementsBarRef, children: checkboxSelection && !checkboxSelection.withoutCheckedElementsBar && ((0, jsx_runtime_1.jsx)(ShowUp_1.ShowUp, { show: !!checkboxSelection.checked.length, children: (0, jsx_runtime_1.jsx)(CheckedElementsBar_1.CheckedElementsBar, { count: checkboxSelection.checked.length, onClean: () => checkboxSelection.toggleChecked([]) }) })) }), (0, jsx_runtime_1.jsxs)(Styled.TableHeader, { "$gridTemplateColumns": getGridTemplateColumns(), ref: tableHeaderRef, children: [checkboxSelection && (0, jsx_runtime_1.jsx)(HeaderCheckboxItem_1.default, { checkboxSelection: checkboxSelection, data: data }), renderHeader()] }), !data.length ? (typeof nothingToShowText === 'string' ? ((0, jsx_runtime_1.jsx)(NothingToShow_1.NothingToShow, { text: nothingToShowText || formatMessage({ id: messages_1.AppMessages['common.noRecords'] }), "data-testid": "table-nothing-to-show-label" })) : (nothingToShowText)) : ((0, jsx_runtime_1.jsx)(overlayscrollbars_react_1.OverlayScrollbarsComponent, { defer: true, options: { scrollbars: { autoHide: 'scroll' } }, children: (0, jsx_runtime_1.jsx)(material_1.List, { ref: tableRef, style: { height: tableHeight }, children: data.map((value) => ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, { title: rowTooltip && rowTooltip(value), followCursor: true, placement: "bottom-start", children: (0, jsx_runtime_1.jsxs)(Styled.TableRow, { "data-testid": value?.testId, "$gridTemplateColumns": getGridTemplateColumns(), "$isRowClickable": !!onClickRow, "$isActive": activeRowId === value.id, "$disabled": rowsDisabled, onClick: () => onClickRow && onClickRow(value), role: undefined, dense: true, children: [checkboxSelection && (0, jsx_runtime_1.jsx)(RowCheckboxItem_1.default, { checkboxSelection: checkboxSelection, value: value }), renderRow(value)] }, value.id) }, value.id))) }) }))] }));
};
const Table = (props) => {
    return ((0, jsx_runtime_1.jsx)(ObserverContextController_1.ObserverContextController, { children: (0, jsx_runtime_1.jsx)(TableBase, { ...props }) }));
};
exports.Table = Table;
exports.Table.RowItem = RowItem_1.default;
exports.Table.RowCheckboxItem = RowCheckboxItem_1.default;
exports.Table.RowTagItem = RowTagItem_1.default;
exports.Table.HeaderItem = HeaderItem_1.default;
